// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__DZf0O","circle-loading":"Loading_circle-loading__bhNIh"};